import { notificationStore } from 'components/layout/notifications/NotificationStore';
import { eventManager } from 'ats/utils/EventManager';
import { applicantStore } from 'ats/pages/applicants/ApplicantStore';
import { jobApplicationStore } from 'ats/pages/pipeline/components/JobApplicationStore';

export const PIN_SCOPES = {
	APPLICANT: 'applicant',
	JOB: 'job'
};

export const isTaskPinned = task => Boolean(task?.pinnedAt);

export async function setTaskPinned({ scope, task, pinned, onSuccess }) {
	const request = { pinned };
	const result =
		scope === PIN_SCOPES.JOB
			? await jobApplicationStore.pinTask(
					task.jobApplicationId,
					task.id,
					request
				)
			: await applicantStore.pinTask(
					task.applicantId ?? task.applicant?.id,
					task.id,
					request
				);

	if (result?.status === 'success') {
		eventManager.emit('taskPinChanged');
		onSuccess?.();
		return true;
	}

	notificationStore.pushErrorNotification(
		pinned ? 'Pin failed' : 'Unpin failed',
		result?.message || 'Failed to update the pin'
	);
	return false;
}

export function getPinMenuItem({ scope, task, onSuccess }) {
	const isPinned = isTaskPinned(task);
	return {
		label: isPinned ? 'Unpin' : 'Pin',
		img: '/ats/icons/pin-note-icon.svg',
		onClick: () => setTaskPinned({ scope, task, pinned: !isPinned, onSuccess })
	};
}
